import {isPlayerFaction} from "../factions/isPlayerFaction";
import {FACTIONS} from "../../constants/factions";
import {FACTION_HUMANS_POLICY_DISCOUNT} from "../../configs/factions/humans";

export const calcPolicyPrice = (index, player) => {
  let price = index + 1;

  if (isPlayerFaction(player, FACTIONS.HUMANS)) {
    price -= FACTION_HUMANS_POLICY_DISCOUNT;
  }

  return Math.max(price, 0);
}